import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import styles from './navigationButton.scss';

function NavigationButton({
  to,
  icon,
  active = false,
  children,
  className,
  ...rest
}) {
  return (
    <ReactLink
      to={to}
      className={classNames(
        styles.navigationButton,
        active && styles.active,
        className
      )}
      {...rest}
      aria-current={active ? 'page' : undefined}
    >
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </ReactLink>
  );
}

NavigationButton.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  icon: PropTypes.node,
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default NavigationButton;
